import { render, staticRenderFns } from "./LoaderResume.vue?vue&type=template&id=06e54c56"
import script from "./LoaderResume.vue?vue&type=script&lang=js"
export * from "./LoaderResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports